import { toast } from "react-toastify"
import { ButtonForm } from "~styled/button"

interface CopyCellProps {
  rowData: string
  text?: string
  classname?: string
  textColor?: string
}

const CopyCell = ({
  rowData,
  text = "",
  classname = "",
  textColor,
}: CopyCellProps) => {
  const copyToClipboard = async (text: string) => {
    await navigator.clipboard.writeText(text)
    toast.info(`📋 Copied to clipboard!`, {
      hideProgressBar: true,
      autoClose: 1000,
      theme: "dark",
    })
  }
  const visibleText = !!text ? text : rowData

  return rowData ? (
    <ButtonForm
      fontSize={15}
      color={textColor}
      className={classname}
      onClick={() => copyToClipboard(rowData)}
    >
      {visibleText}
    </ButtonForm>
  ) : null
}

export default CopyCell
